import type { MouseEvent } from 'react'
import { useEffect, useState } from 'react'

import { Button } from '@skytech/ui/Button'
import VisibilitySensor from 'react-visibility-sensor'

import { Translation } from '@/app/translations/Translation'

import './use-render-limit.styles.scss'

export const useRenderLimit = <T,>(list: T[], renderLimitInit = 50, step = 20) => {
  const [renderLimit, setRenderLimit] = useState(renderLimitInit)

  const increaseRenderLimit = () => setRenderLimit(renderLimit + step)

  useEffect(() => {
    setRenderLimit(renderLimitInit)
  }, [list.length, renderLimitInit])

  return {
    visibleList: list.slice(0, renderLimit),
    ListLoaderComponent: () => (
      <ListLoader
        conditionSelector={() => list.length > renderLimit}
        action={increaseRenderLimit}
      />
    ),
  }
}

const ListLoader = ({
  conditionSelector = () => true,
  // eslint-disable-next-line no-console
  action = () => console.log('list loader visible'),
}) => {
  const isConditionMet = conditionSelector()

  if (!isConditionMet) return null

  const onChange = (event: MouseEvent<HTMLElement>) => event && action()

  return (
    <VisibilitySensor onChange={onChange}>
      <div className="list-loader">
        <Button onClick={onChange}>
          <Translation id="Load more results" />
        </Button>
      </div>
    </VisibilitySensor>
  )
}
